


























































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { FillInfoItemOfForm } from '../../types/type'
import { findItemForTree, disposeFillInfoToParamsForCM, getArrChildForTree, getAllFatherNodeForTree } from '../../utils/toolsForCommon'
import countTo from 'vue-count-to'
import { CommonModule, UserModule, CanteenModule } from '../../store'
import { ElMessageComponent } from 'element-ui/types/message'
@Component({
  name: 'SystemSetting',
  components: {
    'count-to': countTo,
    'in-development': () => import('../../components/common/inDevelopment.vue'),
    'my-dialog': () => import('../../components/common/myDialog.vue')
  }
})
export default class SystemSetting extends Vue {
  public paneName: string = 'schoolBaseInfoContainerModule'
  public informationOverviewBase: Array<FillInfoItemOfForm> = [
    {
      title: '教师数',
      type: 'number',
      key: 'teacherNum',
      value: '',
      placeholder: '请输入教师数',
      content: '',
      isNecessary: true
    },
    {
      title: '学生数',
      type: 'number',
      key: 'studentNum',
      value: '',
      placeholder: '请输入学生数',
      content: '',
      isNecessary: true
    },
    {
      title: '寄宿生数',
      type: 'number',
      key: 'residentStudentNum',
      value: '',
      placeholder: '请输入寄宿生数',
      content: '',
      isNecessary: true
    },
    {
      title: '就餐人数',
      type: 'number',
      key: 'numForSystemSetting',
      value: '',
      placeholder: '请输入就餐人数',
      content: '',
      isNecessary: true,
      child: [
        {
          title: '早餐人数',
          type: 'number',
          key: 'breakfastNum',
          value: '',
          placeholder: '请输入早餐人数',
          content: '',
          isNecessary: true
        },
        {
          title: '中餐人数',
          type: 'number',
          key: 'lunchNum',
          value: '',
          placeholder: '请输入中餐人数',
          content: '',
          isNecessary: true
        },
        {
          title: '晚餐人数',
          type: 'number',
          key: 'dinnerNum',
          value: '',
          placeholder: '请输入晚餐人数',
          content: '',
          isNecessary: true
        }
      ]
    },
    {
      title: '就餐标准',
      type: 'number',
      key: 'standardForSystemSetting',
      value: '',
      placeholder: '请输入就餐就餐标准',
      content: '',
      isNecessary: true,
      child: [
        {
          title: '早餐（元/餐）',
          type: 'number',
          key: 'breakfastPrice',
          value: '',
          placeholder: '早餐标准',
          content: '',
          isNecessary: true
        },
        {
          title: '中餐（元/餐）',
          type: 'number',
          key: 'lunchPrice',
          value: '',
          placeholder: '中餐标准',
          content: '',
          isNecessary: true
        },
        {
          title: '晚餐（元/餐）',
          type: 'number',
          key: 'dinnerPrice',
          value: '',
          placeholder: '晚餐标准',
          content: '',
          isNecessary: true
        }
      ]
    },
    {
      title: '记账人',
      type: 'text',
      key: 'bookkeepers',
      value: '',
      placeholder: '请输入记账人',
      content: '',
      isNecessary: true
    },
    {
      title: '制单人',
      type: 'text',
      key: 'billmakers',
      value: '',
      placeholder: '请输入制单人',
      content: '',
      isNecessary: true
    },
    {
      title: '审核人',
      type: 'text',
      key: 'reviewers',
      value: '',
      placeholder: '请输入审核人',
      content: '',
      isNecessary: true
    }
  ]
  public loadingForInformationOverviewContent: boolean = false
  public flagForCanEditor: boolean = false
  public detailInfo: any = {}
  // charts：
  public myChartForEchartsContainerForTopLeft: any = null
  public myChartForEchartsContainerForTopRight: any = null
  public myChartForEchartsContainerForBottom: any = null
  public optionForEchartsContainerForTopLeft: any = {
    title: {
      text: '教师-学生',
      subtext: '人数占比',
      left: 'center'
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      left: 'left'
    },
    color: ['#C1BAFB', '#F8B594'],
    series: [
      {
        name: '人数（人）',
        type: 'pie',
        radius: '50%',
        data: [
          { value: 0, name: '教师' },
          { value: 0, name: '学生' }
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  }
  public optionForEchartsContainerForTopRight: any = {
    title: {
      text: '学生-寄宿生',
      subtext: '人数占比',
      left: 'center'
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      left: 'left'
    },
    color: ['#BFEDD6', '#73E0E4'],
    series: [
      {
        name: '人数（人）',
        type: 'pie',
        radius: '50%',
        data: [
          { value: 0, name: '学生' },
          { value: 0, name: '寄宿生' }
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  }
  public optionForEchartsContainerForBottom = {
    title: {
      text: '就餐信息',
      subtext: '早中晚变化情况',
      left: 'center'
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    legend: {
      left: 'left'
    },
    xAxis: {
      type: 'category',
      data: ['早餐', '中餐', '晚餐']
    },
    yAxis: {
      type: 'value'
    },
    color: ['#A2E676', '#F8B594'],
    series: [
      {
        name: '就餐人数',
        data: [0, 0, 0],
        type: 'line'
      },
      {
        name: '就餐标准',
        data: [0, 0, 0],
        type: 'line'
      }
    ]
  }
  // 插入初期余额相关：
  public filterText = ''
  public defaultProps: any = {
    children: 'children',
    label: 'name'
  }
  public portalQuerySubjectInitBalanceList: any[] = []
  public portalQuerySubjectInitBalanceMap: Map<string, string> = new Map()
  public balanceForInput: string = ''
  public setForWho: any = null
  public dialogFlagForInsertSubjectInitBalance: boolean = false
  public loadingForInsertSubjectInitBalance: boolean = false
  public treeDataForDisposeNameSubjectCopy: any[] = []
  public loadingForCanteenSubjectContent: boolean = false
  // 专门针对初期余额的修改，匹配到相应的id：
  public portalQuerySubjectInitMap: Map<string, string> = new Map()

  // 针对组织架构：
  public filterTextOrganization = ''
  public tableDataSchoolBaseInfo: any = []
  public checkedKeysForTreeOrganization: Array<string | number> = []

  get treeDataForDisposeNameSubject () {
    return CanteenModule.treeDataForDisposeNameSubject
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get userInfo () {
    return UserModule.userInfo
  }

  get orgName (): string {
    const org = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
    return org && org['name'] ? org['name'] : '- -'
  }

  get thisSchoolName (): string {
    if (!this.checkedKeysForTreeOrganization) return '- -'
    const org = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.checkedKeysForTreeOrganization[0])
    return org && org['name'] ? org['name'] : '- -'
  }

  @Watch('filterText') filterTextChange (val: any) {
    (this.$refs.tree as any).filter(val)
  }

  @Watch('filterTextOrganization') filterTextOrganizationChange (val: any) {
    (this.$refs.treeOrganization as any).filter(val)
  }

  async mounted () {
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization()
    ])
    this.initCharts()
    this.updateCharts(this.myChartForEchartsContainerForTopLeft, this.optionForEchartsContainerForTopLeft)
    this.updateCharts(this.myChartForEchartsContainerForTopRight, this.optionForEchartsContainerForTopRight)
    this.updateCharts(this.myChartForEchartsContainerForBottom, this.optionForEchartsContainerForBottom)
    // 处理树的默认选择且获取学校详情：
    this.$nextTick(() => {
      const schoolList = getArrChildForTree(this.treeDataForSubOrganatizion, 'children').map(item => item.id)
      ;(this as any).$refs.treeOrganization.setCheckedKeys(schoolList.length ? schoolList.slice(0, 1) : [])
      this.checkedKeysForTreeOrganization = schoolList.length ? schoolList.slice(0, 1) : []
      this.getDetailInfo()
    })
    this.loadingForCanteenSubjectContent = true
    await CanteenModule.getTreeDataForDisposeNameSubject()
    this.loadingForCanteenSubjectContent = false
    this.treeDataForDisposeNameSubjectCopy = JSON.parse(JSON.stringify(this.treeDataForDisposeNameSubject))
    this.getPortalQuerySubjectInitBalance()
  }

  // 更新左侧详情和右侧图表：
  updateInfoAndCharts (info) {
    this.informationOverviewBase = this.informationOverviewBase.map(item => {
      const { key } = item
      switch (key) {
        case 'numForSystemSetting':
        case 'standardForSystemSetting':
          item.child = item.child.map(v => {
            v.value = info[v.key]
            v.content = info[v.key]
            return v
          })
          break
        default:
          item.value = info[key]
          item.content = info[key]
          break
      }
      return item
    })
    this.optionForEchartsContainerForTopLeft.series[0].data[0].value = info['teacherNum']
    this.optionForEchartsContainerForTopLeft.series[0].data[1].value = info['studentNum']
    this.optionForEchartsContainerForTopRight.series[0].data[0].value = info['studentNum']
    this.optionForEchartsContainerForTopRight.series[0].data[1].value = info['residentStudentNum']
    this.optionForEchartsContainerForBottom.series[0].data = [info['breakfastNum'], info['lunchNum'], info['dinnerNum']]
    this.optionForEchartsContainerForBottom.series[1].data = [info['breakfastPrice'], info['lunchPrice'], info['dinnerPrice']]
    this.updateCharts(this.myChartForEchartsContainerForTopLeft, this.optionForEchartsContainerForTopLeft)
    this.updateCharts(this.myChartForEchartsContainerForTopRight, this.optionForEchartsContainerForTopRight)
    this.updateCharts(this.myChartForEchartsContainerForBottom, this.optionForEchartsContainerForBottom)
  }

  async getDetailInfo (): Promise<ElMessageComponent | void> {
    try {
      const resultListForTreeOrganization = (this as any).$refs.treeOrganization.getCheckedKeys(true)
      const params = {}
      if (resultListForTreeOrganization.length) {
        Object.assign(params, {
          orgId: resultListForTreeOrganization[0]
        })
      }
      this.loadingForInformationOverviewContent = true
      const { data: result } = await (this as any).$http.portalGetCanteenInfo(params)
      this.loadingForInformationOverviewContent = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.tableDataSchoolBaseInfo = (result.data.records || []).map(item => {
        if (item['orgId']) {
          const schoolAllFather = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', item['orgId'])
          const idForTown = schoolAllFather[schoolAllFather.length - 2]
          if (idForTown) {
            const resForTown = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', idForTown)
            item['villagesAndTownsName'] = (resForTown as any).name
          }
        }
        return item
      })
      this.detailInfo = (result.data.records.length && result.data.records[0]) || {}
      this.updateInfoAndCharts(this.detailInfo)
    } catch (err) {
      console.log(err)
    }
  }

  async submitForInformationOverview () {
    try {
      const resultListForTreeOrganization = (this as any).$refs.treeOrganization.getCheckedKeys(true)
      const params = disposeFillInfoToParamsForCM(this.informationOverviewBase)
      if (resultListForTreeOrganization.length) {
        Object.assign(params, {
          orgId: resultListForTreeOrganization[0]
        })
      }
      if (this.detailInfo.id) {
        Object.assign(params, {
          id: this.detailInfo.id
        })
      }
      const { data: result } = await (this as any).$http.portalSaveCanteenInfo(params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success('学校基本情况提交成功')
      setTimeout(() => {
        this.flagForCanEditor = false
        this.getDetailInfo()
      }, 500)
    } catch (err) {
      console.log(err)
    }
  }

  initCharts () {
    const _that: any = this
    this.myChartForEchartsContainerForTopLeft = (this as any).$echarts.init(document.getElementById('echartsContainerForTopLeft'))
    this.myChartForEchartsContainerForTopRight = (this as any).$echarts.init(document.getElementById('echartsContainerForTopRight'))
    this.myChartForEchartsContainerForBottom = (this as any).$echarts.init(document.getElementById('echartsContainerForBottom'))
    window.addEventListener('resize', function () {
      _that.myChartForEchartsContainerForTopLeft.resize()
      _that.myChartForEchartsContainerForTopRight.resize()
      _that.myChartForEchartsContainerForBottom.resize()
    })
  }

  updateCharts (who: any, option: any) {
    who.setOption(option, true)
  }

  // 查询初期余额：
  async getPortalQuerySubjectInitBalance () {
    try {
      this.loadingForCanteenSubjectContent = true
      const params = {
        school: this.userInfo.organizationId
      }
      const { data: result } = await (this as any).$http.portalQuerySubjectInitBalance(params)
      this.loadingForCanteenSubjectContent = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.portalQuerySubjectInitBalanceList = (result.data || [])
      this.portalQuerySubjectInitBalanceList.forEach(item => {
        this.portalQuerySubjectInitBalanceMap.set(item.subject, item.balance)
        // 除了以上的，再加一个新的map:
        this.portalQuerySubjectInitMap.set(item.subject, item)
      })
      // 给每一项科目匹配上初期余额：start
      const dataForCopy = JSON.parse(JSON.stringify(this.treeDataForDisposeNameSubjectCopy))
      const dispose = (tree, children) => {
        tree.forEach(item => {
          if (item[children] && item[children].length) {
            dispose(item[children], children)
          }
          if (this.portalQuerySubjectInitBalanceMap.has(item.code)) {
            item.balanceForResult = this.portalQuerySubjectInitBalanceMap.get(item.code)
            // item.showIconForEdit = false
            // 现在又可以修改初期余额了
            item.showIconForEdit = true
            // 添加是编辑的标识：
            item.isEdit = true
            item.id = (this.portalQuerySubjectInitMap.get(item.code) || {})['id']
          } else {
            item.balanceForResult = '未填写'
            item.showIconForEdit = true
          }
          item.flagForShowInput = false
        })
      }
      dispose(dataForCopy, 'children')
      this.treeDataForDisposeNameSubjectCopy = dataForCopy
      // 给每一项科目匹配上初期余额：end
    } catch (err) {
      console.log(err)
    }
  }

  filterNode (value: any, data: any) {
    if (!value) return true
    return data.name.indexOf(value) !== -1
  }

  // 点击插入初期余额：
  operationForInsertSubjectInitBalance (data) {
  // 暂时不要这种弹框方式：
    // this.setForWho = data
    // this.dialogFlagForInsertSubjectInitBalance = true
    // if (data.balanceForResult !== '未填写') {
    //   this.balanceForInput = data.balanceForResult
    // }
    // 新的方式：
    this.setForWho = data
    const dataForCopy = JSON.parse(JSON.stringify(this.treeDataForDisposeNameSubjectCopy))
    const dispose = (tree, children) => {
      tree.forEach(item => {
        if (item[children] && item[children].length) {
          dispose(item[children], children)
        }
        if (data.code === item.code) {
          item.flagForShowInput = true
        } else {
          item.flagForShowInput = false
        }
      })
    }
    dispose(dataForCopy, 'children')
    this.treeDataForDisposeNameSubjectCopy = dataForCopy
    if (data.balanceForResult !== '未填写') {
      this.balanceForInput = data.balanceForResult
    } else {
      this.balanceForInput = ''
    }
  }

  async confirmForInsertSubjectInitBalance () {
    try {
      // this.$confirm('确定要保存此初期余额吗，保存将不可修改哦？', '提示', {
      //   confirmButtonText: `继续保存`,
      //   cancelButtonText: `我再想想`,
      //   type: 'warning'
      // }).then(async () => {
      if (this.balanceForInput === '') return this.$message.warning('请输入初期余额')
      this.loadingForInsertSubjectInitBalance = true
      const params = {
        balance: this.balanceForInput,
        school: this.userInfo.organizationId,
        subject: this.setForWho.code
      }
      let api = ''
      let messageHint = ''
      if (this.setForWho.isEdit) {
        api = 'portalUpdateSubjectInitBalance'
        messageHint = '更新'
        Object.assign(params, {
          id: this.setForWho.id
        })
      } else {
        api = 'portalInsertSubjectInitBalance'
        messageHint = '插入'
      }
      const { data: result } = await (this as any).$http[api](params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.loadingForInsertSubjectInitBalance = false
      this.$message.success(`为${this.setForWho.name}${messageHint}初期余额成功`)
      this.dialogFlagForInsertSubjectInitBalance = false
      this.getPortalQuerySubjectInitBalance()
      // }).catch(() => {})
    } catch (err) {
      console.log(err)
    }
  }

  beforeLeave (activeName: string): void {
    this.$router.replace({ name: 'SystemSetting', query: { paneName: activeName } })
    this.paneName = activeName
    this.getDateForWho()
  }

  getDateForWho () {
    switch (this.paneName) {
      case 'schoolBaseInfoContainerModule':
        this.getDetailInfo()
        break
      case 'initializeContainerModule':
        this.getPortalQuerySubjectInitBalance()
        break
    }
  }

  // 限制表单：
  proving (item, e) {
    if (item.type !== 'number') return
    const keynum = window.event ? e.keyCode : e.which
    if (keynum == 189 || keynum == 190 || keynum == 110 || keynum == 109) {
      this.$message({
        message: '禁止输入小数以及负数',
        type: 'warning',
        offset: 80
      })
      e.target.value = ''
      item.value = ''
    } else if (keynum == 69) {
      this.$message({
        message: '禁止输入字母',
        type: 'warning',
        offset: 80
      })
      e.target.value = ''
      item.value = ''
    }
  }

  operationForDownload () {
    this.loadingForCanteenSubjectContent = true
    const data = []
    const dispose = (tree, children) => {
      tree.forEach(item => {
        let dataItem = []
        if (item[children] && item[children].length) {
          dataItem = [item.name, '无需填写']
          dispose(item[children], children)
        } else {
          dataItem = [item.name, item.balanceForResult]
        }
        data.push(dataItem)
      })
    }
    dispose(this.treeDataForDisposeNameSubjectCopy, 'children')
    import('../../plugins/xlsx/exportExcel').then(excel => {
      try {
        excel.export_json_to_excel({
          multiHeader: [],
          multiHeader2: [],
          header: ['科目名称（科目编号）', '初期余额'],
          autoWidth: true,
          data,
          merges: [],
          filename: '初期余额' + '（' + this.orgName + '）' + '.xlsx'
        })
        this.$message.success('公安县中小学食堂初期余额，导出成功')
      } catch (err) {
        console.log(err, 'err')
        this.$message.error('抱歉，导出失败')
      }
    })
    setTimeout(() => {
      this.loadingForCanteenSubjectContent = false
    }, 300)
  }

  handleCheckChange () {
    const treeDom = (this as any).$refs.treeOrganization
    this.checkedKeysForTreeOrganization = treeDom.getCheckedKeys(true)
    if (this.checkedKeysForTreeOrganization.length) {
      this.getDetailInfo()
    } else {
      this.updateInfoAndCharts({})
    }
  }

  // tree单选：
  handleCheckChangeReal (data, checkbox) {
    const treeDom = (this as any).$refs.treeOrganization
    if (checkbox) {
      treeDom.setCheckedKeys([data.id])
    }
  }
}
